module.exports = __webpack_public_path__ + "static/media/ImgWord2.7c5b2ccd.svg";